import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import {CallDirection} from './consts'
import {EventBus} from '@/event-bus'
import storage from '@utils/storage'
import baseUtils from '@utils/base'

Vue.use(Vuex)

const Connection = {
  online: 0,
  connecting: 1,
  offline: 2
}

let store = new Vuex.Store({
  state: {
    connection: Connection.offline,
    profile: {},
    serverId: '',
    chats:[],
    recents: [],
    contacts: [],
    currentChat: {
      chatId: null,
      users: [],
      single: false,
      ttl: 0,
      muted: false,
      title: ''
    },
    callDirection: CallDirection.unknown, 
    callActive: false,
    settings: {
      language: '',
      background: '',
      fontSize: 14,
      theme: false
    },
  },
  actions,
  mutations: {
    setContacts(state, items) {
      state.contacts = items
      //console.log(`--- setContacts: ${items.length}`)
    },

    setCurrentChat(state, chat) {
      if (chat == null) {
        state.currentChat = {
          chatId: null,
          users: [],
          single: false,
          ttl: 0,
          muted: false,
          title: '',
          readonly: false
        }
        return
      }

      //console.log('--- setCurrentChat', chat)
      Object.keys(chat).forEach(function(key) {
        state.currentChat[key] = chat[key]
      })

      const result = state.chats.find(item => item.chatId === chat.chatId)
      if (result !== undefined) {
        state.currentChat.title = result.title
        state.currentChat.muted = result.muted
      } else {
        const contact = state.contacts.find(c => c.contactId === chat.users[0])
        state.currentChat.title = contact.name
        state.currentChat.muted = false     
      }

      EventBus.$emit('chat-selected')
    },
    setCurrentTtl(state, value) {
      console.log('-- store setCurrentTtl: ' + value)
      state.currentChat.ttl = value
    },
    setChatTtl(state, { chatId, ttl }) {
      let chat = state.chats.find(item => item.chatId === chatId)
      if (chat !== undefined)
        chat.ttl = ttl

      if (state.currentChat.chatId == chatId)
        state.currentChat.ttl = ttl
    },
    setChatAvatar(state, { chatId, data }) {
      let chat = state.chats.find(item => item.chatId === chatId)
      if (chat !== undefined) {
        chat.avatar = data
      }
    },
    setChatMuted(state, { chatId, muted }) {
      console.log('-- store setChatMuted: ' + muted)
      let chat = state.chats.find(item => item.chatId === chatId)
      if (chat !== undefined) {
        chat.muted = muted
      }
      if (state.currentChat.chatId == chatId)
        state.currentChat.muted = muted 
    },

    setRecents(state, items) {
      state.recents = items
    },

    setChats(state, items) {
      state.chats = items
      if (state.currentChat) {
        let chat = state.chats.find(item => item.chatId === state.currentChat.chatId)
        if (chat) {
          state.currentChat.title = chat.title
          state.currentChat.muted = chat.muted          
        }
      }
    },

    setUserProfile(state, profile) {
      if (!baseUtils.equal(state.profile, profile)) {
        state.profile = profile
        EventBus.$emit('user-profile-changed')
      }
    },

    setCallDirection(state, direction) {
      state.callDirection = direction
      state.callActive = (direction != CallDirection.unknown)
      console.log('-- setCallDirection', state.callDirection)
    },

    setSettings(state, sets) {
      Object.keys(sets).forEach(function(key) {
        state.settings[key] = sets[key]
      })
      //console.log('-- setSettings' + JSON.stringify(state.settings))
      storage.set('settings', JSON.stringify(state.settings))
    },

    setServerId(state, serverId) {
      state.serverId = serverId
    },
    setConnectionState(state, connection) {
      console.log('-- setConnectionState', connection)
      state.connection = connection
    }
  },
  getters: {
    getChats: state => state.chats,
    getContacts: state => state.contacts,
    getCurrentChat: state => state.currentChat,
    getContactName: state => contactId => {
      //for (let c in state.contacts) {
      for (let i = 0; i < state.contacts.length; i++) {
        let c = state.contacts[i]
        if (c.contactId === contactId)
          return c.name
      }
      return contactId
    },
    getContactAvatar: state => contactId => {
      // TODO: better use map 
      let it = state.contacts.find(c => c.contactId == contactId)
      return (it) ? it.avatar : ''
    },
    getChatBackground: state => state.settings.background,
    getFontSize: state => state.settings.fontSize,
    getUnreadMessages: state => { 
      let unread = 0
      state.chats.forEach((c) => { unread += c.unread })
      return unread
    },
    isOnline: state => { return (state.connection == Connection.online) },
    getCurrentTtl: state => state.currentChat.ttl,
    isCallIncoming: state => state.callDirection == CallDirection.incoming,
    isCallBusy: state => state.callDirection !== CallDirection.unknown,
    getServerId: state => state.serverId,
    getLanguage: state => state.settings.language,
    isChatMuted: state => chatId => {
      const chat = state.chats.find(c => c.chatId == chatId)
      return chat.muted
    }
  } 
})

export default store